<template>
  <div class="listBox">
    <ul class="sBox">
      <li style="flex: 1">
        <el-input
          v-model="state.params.Params.Key"
          style="width: 15%"
          placeholder="关键字"
          clearable
          @clear="
            delete state.params.Params.Key;
            onLoad();
          "
        ></el-input>
        <el-dropdown
          split-button
          @click="onLoad"
          type="primary"
          style="margin-left: 10px"
        >
          查询
          <template #dropdown>
            <el-dropdown-menu>
              <el-dropdown-item :icon="RefreshLeft" @click="onReset()">
                重置
              </el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown>
      </li>
      
      <li
        style="display: flex; align-items: center"
        v-if="
          $store.state.loginUser?.IsAdmin ||
          $store.state.loginUser?.Qxs?.includes('B_JiuDian_List_添加')
        "
      >
        <el-button
          type="primary"
          icon="Plus"
          link
          @click="
            delete state.selectId;
            state.showCompile = true;
          "
        >
          添加
        </el-button>
      </li>
    </ul>
    <ul class="tBox">
      <el-table
        :data="state.tableData"
        v-loading="!Array.isArray(state.tableData)"
        element-loading-background="rgba(0, 0, 0, 0.2)"
        :default-sort="{
          prop: state.params.Order,
          order: state.params.Asc == false ? 'descending' : 'ascending',
        }"
        @sort-change="onSortChange"
      >
        <el-table-column
          fixed
          label="#"
          width="50"
          type="index"
          :index="
            (index) =>
              (state.params.PageIndex - 1) * state.params.PageSize + index + 1
          "
          align="center"
        />
        <el-table-column
          prop="IsQy"
          sortable="IsQy"
          label="状态"
          align="center"
          width="80"
        >
          <template #default="scope">
            <text :style="{ color: scope.row.IsQy ? '#080' : '#f00' }">
              {{ scope.row.IsQy ? "售卖中" : "停售" }}
            </text>
          </template>
        </el-table-column>
        <el-table-column
          prop="Xj"
          sortable="Xj"
          label="星级"
          align="center"
          width="100"
        />
        <el-table-column
          prop="Mc"
          sortable="Mc"
          label="酒店名称"
          :show-overflow-tooltip="true"
          min-width="300"
        />
        <el-table-column
          prop="GysMc"
          label="供应商"
          :formatter="$tab_TextFormat"
          min-width="120"
        />
        <el-table-column
          label="地址"
          :show-overflow-tooltip="true"
          :formatter="$tab_TextFormat"
          prop="Dz"
          min-width="200"
        />
        <el-table-column
          prop="Dh"
          label="联系电话"
          :formatter="$tab_TextFormat"
          min-width="130"
        />
        <el-table-column
          prop="Zc"
          label="早餐"
          :formatter="$tab_TextFormat"
          width="80"
        />
        <el-table-column
          prop="Fjs"
          label="房间数"
          :formatter="$tab_NumberFormat"
          width="80"
        />
        <el-table-column
          prop="IsYuyue"
          label="预约"
          align="center"
          width="100"
        >
          <template #default="scope">
            <text v-if="scope.row.IsYuyue" style="color: #1779de">
              需预约({{ scope.row.YuyueTianShu }}天)
            </text>
            <text v-else style="color: #999">否</text>
          </template>
        </el-table-column>
        <el-table-column
          prop="Cjsj"
          sortable="Cjsj"
          label="创建信息"
          width="160"
          :formatter="(row) => $tab_GroupFormat(row.CjrXm, row.Cjsj)"
        />
        <el-table-column
          label="操作"
          width="180"
          align="center"
          fixed="right"
          className="tabBtn"
        >
          <template #default="{ row }">
            <el-button
              type="primary"
              :icon="Edit"
              link
              @click="
                $store.commit('openMenu', {
                  path: 'JiuDianDetail',
                  title: '编辑酒店信息',
                  data: { id: row.Id },
                  refresh: true,
                })
              "
              v-if="
                $store.state.loginUser?.IsAdmin ||
                $store.state.loginUser?.Qxs?.includes('B_JiuDian_List_管理') ||
                $store.state.loginUser?.Qxs?.includes('B_JiuDian_List_编辑')
              "
              >管理
            </el-button>
            <el-button
              type="danger"
              :icon="Delete"
              link
              @click="onDelete(row.Id)"
              v-if="
                $store.state.loginUser?.IsAdmin ||
                $store.state.loginUser?.Qxs?.includes('B_JiuDian_List_删除')
              "
              >删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </ul>
    <c_page
      :total="state.totalCount"
      :pageIndex="state.params.PageIndex"
      @onLoad="
        (pageIndex) => {
          state.params.PageIndex = pageIndex;
          onLoad();
        }
      "
    >
    </c_page>
    <transition name="el-zoom-in-center">
      <c_popup
        v-if="state.showCompile"
        :title="(state.selectId ? '修改' : '添加') + '酒店'"
        @close="state.showCompile = false"
      >
        <c_JiuDianCompile
          @close="
            state.showCompile = false;
            onLoad();
          "
          :id="state.selectId"
        ></c_JiuDianCompile>
      </c_popup>
    </transition>
  </div>
</template>

<script>
import { onMounted, reactive } from "vue";
import { jiudian_list, jiudian_delete } from "@/http/api";
import { confirm_func } from "@/util/tFormat";

class InitFormData {
  params = {
    PageSize: 20,
    PageIndex: 1,
    Params: {},
    Order: "Cjsj",
    Asc: false,
  };
}

export default {
  setup() {
    const state = reactive(new InitFormData());
    onMounted(() => {
      onLoad();
    });

    const onLoad = () => {
      delete state.tableData;
      jiudian_list(state.params).then((res) => {
        if (res.status == 200) {
          const { count, list } = res.data;
          state.tableData = list;
          state.totalCount = count;
        }
      });
    };

    //排序
    const onSortChange = (column) => {
      if (column.order) {
        state.params.Order = column.prop;
        state.params.Asc = column.order === "ascending";
      } else {
        state.params.Order = "Cjsj";
        state.params.Asc = false;
      }
      onLoad();
    };

    //重置查询条件
    const onReset = () => {
      Object.assign(state, new InitFormData());
      onLoad();
    };

    //删除
    const onDelete = (id) => {
      confirm_func(jiudian_delete, id, onLoad);
    };

    return {
      state,
      onLoad,
      onSortChange,
      onReset,
      onDelete,
    };
  },
};
</script>
<style>
.drawerCss {
  width: 40vw !important;
}

.drawerCss > div {
  overflow: hidden;
  padding: 0 !important;
}
</style>